<template>
  <div id="button-up">
    <v-btn v-show="fab" position="fixed" location="bottom right" class="button-up ma-3" v-scroll="onScroll" :active="fab" appear app size="44" @click="toTop" title="Ir al principio de la página"
      aria-label="Ir al principio de la página" icon="mdi-chevron-up" role="button">
    </v-btn>
  </div>
</template>
<script setup lang="ts">
import { useGoTo } from 'vuetify'
const goTo = useGoTo()
const fab = ref(false)
function onScroll(e) {
  if (typeof window === "undefined") return;
  const top = window.scrollY || 0;
  // Solo aparece cuando se ha bajado una parte significativa de la página
  fab.value = top > Math.max(300, window.innerHeight * 0.5);
}
function toTop() {
  const reducirMovimiento = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  goTo(0, { duration: reducirMovimiento ? 0 : 500 });
}
onScroll(null)
</script>

<style scoped>
/* Fondo oscuro con icono blanco: se distingue sobre cualquier fondo (claro u oscuro) de las webs de las notarías */
.button-up {
  background-color: rgba(30, 30, 30, 0.85) !important;
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25) !important;
  transition: transform 0.2s ease, background-color 0.2s ease;
}
.button-up:hover {
  background-color: rgba(0, 0, 0, 0.95) !important;
  transform: translateY(-2px);
}
.button-up:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 2px;
}
@media (prefers-reduced-motion: reduce) {
  .button-up { transition: none; }
  .button-up:hover { transform: none; }
}
</style>
